import { Color } from 'three'

const cyanora = new Color(0.01, 0.41, 0.85)

const coalMineCanary = new Color(1, 0.45, 0.01)

const futureFuscia = new Color(0.92, 0.075, 0.25)

export const colors = {
    cyanora: cyanora,
    '#3cd0f5': cyanora,
    'coal-mine-canary': coalMineCanary,
    '#fcd411': coalMineCanary,
    'future-fuscia': futureFuscia,
    '#f6629d': futureFuscia,
}

export const TOKEN_SCALE_MULTIPLIER = 1.2
export const DEFAULT_DRIFT = 100
